<template>
  <svg :width="size" :height="size" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M9.20903 0.816077C9.16023 0.555369 9.00986 0.324725 8.79101 0.174883C8.57215 0.0250415 8.30274 -0.0317232 8.04203 0.0170767C7.78132 0.0658765 7.55068 0.216243 7.40084 0.435098C7.25099 0.653953 7.19423 0.923369 7.24303 1.18408L7.56803 2.92408C6.54093 3.45249 5.71285 4.29968 5.20802 5.33857C4.70318 6.37745 4.5488 7.55202 4.76803 8.68608L5.04403 10.1591L5.09903 10.4551C5.35703 11.8291 4.87103 12.7171 4.46903 13.4531C4.18403 13.9731 3.94203 14.4171 4.03203 14.9021C4.14203 15.4881 4.25203 16.0751 4.78203 15.9761L17.482 13.5991C18.01 13.4991 17.9 12.9141 17.79 12.3291C17.687 11.7651 17.154 11.2061 16.595 10.6181C15.989 9.98208 15.352 9.31208 15.191 8.56708C14.958 7.48208 14.916 7.18008 14.888 6.98008C14.879 6.91708 14.872 6.86308 14.86 6.79808C14.6346 5.54978 13.9721 4.42251 12.9913 3.61813C12.0105 2.81375 10.7753 2.38479 9.50703 2.40808L9.20903 0.816077Z"
      :fill="color"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M4.53907 1.27802C4.73551 1.45603 4.85324 1.70476 4.86636 1.96953C4.87949 2.23431 4.78694 2.49346 4.60907 2.69002C3.49407 3.92002 2.90407 5.29502 2.77907 6.95002C2.75918 7.21458 2.63501 7.46039 2.43387 7.6334C2.23274 7.8064 1.97112 7.89242 1.70657 7.87252C1.44201 7.85263 1.1962 7.72846 1.0232 7.52733C0.850194 7.3262 0.764177 7.06458 0.784068 6.80002C0.944068 4.70102 1.71307 2.90702 3.12607 1.34702C3.21429 1.24968 3.32083 1.17067 3.43961 1.11451C3.55838 1.05835 3.68705 1.02615 3.81827 1.01974C3.94949 1.01334 4.08069 1.03285 4.20437 1.07717C4.32805 1.12148 4.44178 1.18974 4.53907 1.27802Z"
      :fill="color"
    />
    <path
      d="M6.94995 16.7C7.64995 17.5 8.64995 18 9.74995 18C11.35 18 12.65 16.9 13.05 15.5L6.94995 16.7Z"
      :fill="color"
    />
  </svg>
</template>

<script>
export default {
  name: 'NotificationTiltedIcon',
  props: {
    color: {
      type: String,
      default: '#B40007'
    },
    size: {
      type: String,
      default: '18'
    }
  }
}
</script>
